'use client'

import { useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'

export const ScrollToProducts = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const searchParams = useSearchParams()
  const scrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const shouldScroll = searchParams.get('scroll-to-products') === 'true'
    if (shouldScroll && scrollRef.current) {
      const timer = setTimeout(() => {
        scrollRef.current?.scrollIntoView({ behavior: 'smooth' })
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [searchParams])

  return (
    <div ref={scrollRef} className='scroll-mt-25 md:scroll-mt-30'>
      {children}
    </div>
  )
}
